import React, { useState } from "react";
import { Button, Modal, Toast, ToastContainer } from "react-bootstrap";
import { useLocation } from "react-router-dom";
import { AdsListPageControllerImpl, AdsStrings } from "../../../../business";
import { AdsListResponse } from "../../../interfaces";
import "../assets/css/ads-list.css";
import { AdsListItem } from "./";

export const AdsList: React.FC<AdsListResponse> = ({ data }) => {
    const [location, setLocation] = useState(useLocation());
    const strings = AdsStrings['PTBR'].list;
    const [showModal, setShowModal] = useState<boolean>(false);
    const [adsIdToDelete, setAdsIdToDelete] = useState<string>('');
    const handleShowModal = (adsId) => {
        setShowModal(true);
        setAdsIdToDelete(adsId);
    };
    const handleCloseModal = () => setShowModal(false);
    const [isToasting, setToasting] = useState(false);
    const [isProccessing, setProccessing] = useState(false);
    const controller = new AdsListPageControllerImpl();

    const handleDeleteAds = async () => {
        setProccessing(true);
        const response = await controller.adsDelete(adsIdToDelete);
        if (response.success) {
            setLocation({
                state: {
                    showToast: true,
                    text: strings.deleted,
                    date: new Date().toISOString(),
                },
            });
            window.location.reload();
        }
        setProccessing(false);
        handleCloseModal();
    };

    return (
        <>
            <AdsListItem data={data} deleteModal={handleShowModal} strings={strings} />
            <Modal
                show={showModal}
                onHide={handleCloseModal}
                backdrop="static"
                keyboard={false}
            >
                <Modal.Header closeButton>
                    <Modal.Title>{strings.delete_modal.title}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p
                        dangerouslySetInnerHTML={{ __html: strings.delete_modal.description }}
                    />
                </Modal.Body>
                <Modal.Footer className="justify-content-between">
                    <Button
                        variant="secondary"
                        onClick={handleCloseModal}
                        disabled={isProccessing}
                    >
                        {strings.delete_modal.buttons.cancel}
                    </Button>
                    <Button
                        variant="danger"
                        onClick={() => handleDeleteAds()}
                        disabled={isProccessing}
                    >
                        {strings.delete_modal.buttons.proceed}
                    </Button>
                </Modal.Footer>
            </Modal>
            <ToastContainer position="top-end" className="p-3" style={{ zIndex: 1 }}>
                <Toast
                    bg={"success"}
                    onClose={() => setToasting(false)}
                    show={isToasting}
                    delay={5000}
                    autohide
                >
                    <Toast.Header>
                        {location.state?.image ? (
                            <img
                                src={location.state?.image}
                                className="rounded me-2"
                                alt=""
                                width={80}
                            />
                        ) : null}
                        <strong className="me-auto">Montacar</strong>
                    </Toast.Header>
                    <Toast.Body className={"text-white"}>
                        {isToasting ? location.state?.text : null}
                    </Toast.Body>
                </Toast>
            </ToastContainer>
        </>
    );
};
